import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { paginationActions as actions, paginationActions } from '.';
import { queryInfoWithPagiType } from './types';
import fetchClient from 'utils/requestInterceptor';
import { PaginationPayload } from 'types/models';
import { displayError } from 'app/components/ToasterBar/helpers';

export const queryBuilder = (
  filters: string,
  sorts: string,
  page: number,
  page_size: number,
) => {
  let query: string[] = [];
  if (filters) {
    query.push(`filters=${filters}`);
  }

  if (sorts) {
    query.push(`sorts=${sorts}`);
  }

  if (page > 0) {
    query.push(`page=${page}`);
  }

  if (page_size > 0) {
    query.push(`page-size=${page_size}`);
  }

  if (query.length > 1) return `?${query.join('&')}`;
  return '';
};

export function* initPaginationSaga(
  action: PayloadAction<queryInfoWithPagiType>,
) {
  if (action.type !== paginationActions.goToPage.type) {
    try {
      const { filters, sorts, page, page_size, path } = action.payload;
      const { data }: { data: PaginationPayload<any> } = yield call(
        fetchClient.get,
        `${path}${queryBuilder(filters, sorts, page + 1, page_size)}`,
      );
      yield put(
        paginationActions.updatePageData({
          current_page: data.current_page - 1,
          total_count: data.total_count,
          total_pages: data.total_pages,
          page_size: data.page_size,
          contents: data.contents,
          pagiType: action.payload.pagiType,
        }),
      );
    } catch (err) {
      yield put(
        paginationActions.loadPageDataFailed({
          page: action.payload.page,
          pagiType: action.payload.pagiType,
        }),
      );
      yield call(displayError, err);
    }
  }
}

export function* paginationSaga() {
  //The race is when user go back to a loaded page and forth to an unloaded page quickly
  yield takeLatest(
    [actions.initPageData.type, actions.goToPage.type],
    initPaginationSaga,
  );
}
